// Hides the "Discount: High to Low" option from the Searchanise sort-by dropdown.
// Searchanise doesn't expose a setting to remove individual sort options, so this
// strips it client-side instead. The dropdown re-renders its <li> options on each
// search/filter change, so a MutationObserver re-runs the removal after Searchanise loads.

(function () {
  const DISCOUNT_SORT_OPTION_SELECTOR = 'a.snize-main-panel-dropdown-discount-desc';

  function removeDiscountSortOption() {
    document.querySelectorAll(DISCOUNT_SORT_OPTION_SELECTOR).forEach(function (option) {
      (option.closest('li') || option).remove();
    });
  }

  let debounceTimer;
  function scheduleRemoval() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(removeDiscountSortOption, 50);
  }

  document.addEventListener('Searchanise.Loaded', function () {
    scheduleRemoval();
    new MutationObserver(scheduleRemoval).observe(document.body, { childList: true, subtree: true });
  }, { once: true });

  document.addEventListener('Searchanise.DataRequestEnd', scheduleRemoval);
})();
